import { Heading, Text, purpleBase } from "@RooUI";
import React, { useEffect, useState } from "react";

import * as UserType from "../constants/UserTypeConstants";
import petStar from "../static/images/Pet Star.svg";

import {
  hospitalInformationProps,
  studentInformationProps,
  techInformationProps,
  vetInformationProps,
} from "./constants";
import { InfoValuePropContainer } from "./styles";

function InformationalValueProps({
  userType,
  className,
}: {
  userType: number;
  className?: string;
}) {
  const [animate, setAnimate] = useState(false);
  const [infoValueProps, setInfoValueProps] = useState(vetInformationProps);

  useEffect(() => {
    setAnimate(true);
    const timeout = setTimeout(() => {
      switch (userType) {
        case UserType.HOSPITAL_USER_TYPE:
          setInfoValueProps(hospitalInformationProps);
          break;
        case UserType.VET_USER_TYPE:
          setInfoValueProps(vetInformationProps);
          break;
        case UserType.TECH_USER_TYPE:
          setInfoValueProps(techInformationProps);
          break;

        case UserType.STUDENT_USER_TYPE:
          setInfoValueProps(studentInformationProps);
          break;
      }
      setAnimate(false);
    }, 300);
    return () => clearTimeout(timeout);
  }, [userType]);
  return (
    <InfoValuePropContainer className={className} $animate={animate}>
      {infoValueProps.map((prop) => {
        return (
          <div key={prop.title}>
            <img src={petStar} />
            <span>
              <Heading level={3} color={purpleBase}>
                {prop.title}
              </Heading>
              <Text>{prop.description}</Text>
            </span>
          </div>
        );
      })}
    </InfoValuePropContainer>
  );
}

// eslint-disable-next-line no-restricted-exports
export default InformationalValueProps;
